// Generated by purs version 0.15.15
import * as Restaumatic_Form_DynamicResult from "../Restaumatic.Form.DynamicResult/index.js";
import * as Restaumatic_Form_Query from "../Restaumatic.Form.Query/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
var queryTotal = function (dictQuery) {
    var $7 = Restaumatic_Form_Query.queryImpl(dictQuery)(Restaumatic_Form_Query.Lax.value);
    return function ($8) {
        return Restaumatic_Form_DynamicResult.toTotal($7($8));
    };
};
var readTotal = function (dictMonadEffect) {
    var readDynamic = Specular_FRP_Base.readDynamic(dictMonadEffect);
    return function (dictQuery) {
        var $9 = queryTotal(dictQuery);
        return function ($10) {
            return readDynamic($9($10));
        };
    };
};
export {
    queryTotal,
    readTotal
};
